import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

const StaticTextValue = ({ staticText }) => (
  <Input fluid readOnly value={staticText} />
);

StaticTextValue.propTypes = {
  staticText: PropTypes.string.isRequired,
};

export default StaticTextValue;
